import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as applicationActions from '../../actions/application';
import { APPLICATION_CONTEXTS } from '../../constants';
import ImageBackground from '../common/imageBackground';
import NavigationBar from '../common/navigationBar';
import './styles.css';

class PatientGuide extends Component {
  /**************
   * Properties *
   **************/
  state = {
    currentPage: 0,
    pages: [
      require('./images/PatientGuide_VisitorHealth.png'),
      require('./images/PatientGuide_GeneralVisitingHours.png'),
      require('./images/PatientGuide_NoiseLevel.png'),
      require('./images/PatientGuide_Internet.png'),
      require('./images/PatientGuide_Parking.png'),
    ],
    navigationBar: {
      back: true,
      backRoute: '/main_menu',
      mainMenu: true,
      navigate: true,
    },
  };

  /*******************
   * Private methods *
   *******************/

  goToPage = (pageNumber) => {
    this.setState({
      currentPage: pageNumber,
    });
  };

  handlePageUp = () => {
    let nextPageNumber = this.state.currentPage + 1;
    if (nextPageNumber >= this.state.pages.length) {
      nextPageNumber = 0;
    }
    this.goToPage(nextPageNumber);
  };

  handlePageDown = () => {
    let nextPageNumber = this.state.currentPage - 1;
    if (nextPageNumber < 0) {
      nextPageNumber = this.state.pages.length - 1;
    }
    this.goToPage(nextPageNumber);
  };

  handleOnKeyUp = (event) => {
    if (this.props.context !== APPLICATION_CONTEXTS.SERVICES) {
      return;
    }
    switch (event.key) {
      case 'ArrowDown':
        this.handlePageUp();
        break;
      case 'ArrowUp':
        this.handlePageDown();
        break;
      default:
    }
  };

  /*******************
   * Lifecycle hooks *
   *******************/

  /**
   * Performs various actions for component that will mount.
   *
   * This method will add a listener for the `keyup` event.
   *
   * @protected
   *
   **/
  componentWillMount() {
    document.addEventListener('keyup', this.handleOnKeyUp, false);
  }

  /**
   * Performs various actions for component that will unmount.
   *
   * This method will remove the listener for the `keyup` event.
   *
   * @protected
   *
   **/
  componentWillUnmount() {
    document.removeEventListener('keyup', this.handleOnKeyUp);
  }

  /******************
   * Public methods *
   ******************/

  /**
   * Renders the component.
   *
   * @public
   *
   * @returns {React.Component}  The rendered view of the component.
   *
   **/
  render() {
    const pageIndex = this.state.currentPage;
    return (
      <div className="service-patient-guide">
        <ImageBackground id="background" />
        <img className="screen" src={this.state.pages[pageIndex]} alt="" />
        <button className="top-link" onClick={this.handlePageDown}></button>
        <button className="bottom-link" onClick={this.handlePageUp}></button>
        <NavigationBar {...this.state.navigationBar} />
      </div>
    );
  }
}

const ConnectedPatientGuide = connect(
  (state) => ({
    context: state.application.currentContext,
  }),
  (dispatch) => ({
    actions: bindActionCreators(
      {
        ...applicationActions,
      },
      dispatch
    ),
  })
)(PatientGuide);

export default withRouter(ConnectedPatientGuide);
